import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import OImage from "components/reusable/OImage";
import { useForm } from "react-hook-form";
import { useNavigate, useLocation } from "react-router-dom";
const ViewExpert = (item) => {
  const { t } = useTranslation();
  let location = useLocation();
  const [is_redirect, setRedirect] = useState(false);
  const [profilePic, setProfilePic] = useState(location?.state?.images || null);
  const navigate = useNavigate();
  const [editData, setEditData] = useState(location.state);
  const {
    register,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    shouldFocusError: true,
    defaultValues: {
      name: editData?.name,
      experience: editData?.experience,
      whatsapp: editData?.whatsAppNumber,
      categoryId: editData?.categoryDetails?.title
    },
  });

  const getBack = () => {
    setRedirect(true);
    navigate("/consultation-manager", {state: { from: 'expert'}});
  };


  if (is_redirect) {
    return navigate("/consultation-manager", {state: { from: 'expert'}});
  }

  return (
    <div className="py-4 px-4 md:px-8 bg-gray-50">
      <div className="border-0 relative flex flex-col w-full  outline-none focus:outline-none">
        <h2 className="font-medium text-black dark:text-white mb-3 text-xl">
          {t("VIEW_EXPERT")}
        </h2>
        <div className="flex gap-4 items-start w-full">
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="text"
                  name="name"
                  id="name"
                  disabled
                  maxLength={51}
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("name")}
                />
                <label
                  htmlFor="name"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_NAME")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                <input
                  type="number"
                  name="experience"
                  disabled
                  id="experience"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("experience")}
                />
                <label
                  htmlFor="experience"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_EXPERIENCE")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="">
              <div className="relative z-0 mb-6 w-full group">
                  <input
                    type="text"
                    name="categoryId"
                    id="categoryId"
                    disabled
                    className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    maxLength={31}
                    {...register("categoryId")}
                  />

                <label
                  htmlFor="categoryId"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_CATEGORIES")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>
            <div className="mb-6">
            <div className="relative z-0 mb-6 w-full group">
                <input
                  type="number"
                  name="whatsapp"
                  disabled
                  id="whatsapp"
                  className="block py-4 px-3 w-full text-sm text-gray-900 bg-transparent border-2 rounded-lg border-[#DFDFDF] appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                  placeholder=" "
                  {...register("whatsapp")}
                />
                <label
                  htmlFor="whatsapp"
                  className="peer-focus:font-normal absolute text-sm text-[#A5A5A5] dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 left-3 bg-white p-2 z-10 origin-[2] peer-focus:left-0 peer-focus:text-[#A5A5A5] peer-focus:text-lg peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8"
                >
                  {t("O_WHATSAPP_NUMBER")}
                  <span className="text-red-500">*</span>
                </label>
              </div>
            </div>

            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
              <button
                className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                type="button"
                onClick={getBack}
              >
                {t("O_BACK")}
              </button>
            </div>
          </div>
          <div className="w-1/2 rounded-lg border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-7">
            <div className="">
              <h3 className="font-medium text-black dark:text-white mb-3 text-lg">
                Upload Profile
              </h3>
            </div>

            {!profilePic ? t("O_N/A") : (
              <div className="relative">
                <OImage
                  src={typeof profilePic === 'object' ? URL.createObjectURL(profilePic) : profilePic}
                  fallbackUrl="/images/imagesBanner.png"
                    className="w-full h-full border relative"
                  alt=""
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewExpert;
